import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Button } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

export function RefreshButton({ isRefreshing, onClick }: { isRefreshing: boolean; onClick?: () => void }) {
  useLingui()
  return (
    <Button disabled={isRefreshing} startIcon={<RefreshIcon />} onClick={onClick}>
      <Trans>Refresh</Trans>
    </Button>
  )
}
